module.exports = __webpack_public_path__ + "img/qrcode-zixun.e4f18e7b.jpg";